import type { Mirror } from "@/lib/mirror"
import { isArray } from "@/lib/validation/isArray"
import { isRecord } from "@/lib/validation/isRecord"
import { isStringKeyedRecord } from "@/lib/validation/isStringKeyedRecord"

export const isValidMirror = (subject: unknown): subject is Mirror<unknown> => {
  if (!isRecord(subject)) {
    return false
  }

  if (!isArray(subject.array)) {
    return false
  }

  if (!isStringKeyedRecord(subject.collection)) {
    return false
  }

  return true
}
